import { cn } from '@/utils/tailwind-util'
import { ReactNode } from 'react'

interface PageContainerProps {
  className?: string
  children: ReactNode
}

export const PageContainer = ({ children, className }: PageContainerProps) => {
  return (
    <div className={cn("container mx-auto pb-10 space-y-6", className)}>
      {children}
    </div>
  )
}
